import { render, staticRenderFns } from "./WidgetChildItems.vue?vue&type=template&id=d9a6326c&scoped=true&"
import script from "./WidgetChildItems.vue?vue&type=script&lang=js&"
export * from "./WidgetChildItems.vue?vue&type=script&lang=js&"
import style0 from "./WidgetChildItems.vue?vue&type=style&index=0&id=d9a6326c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a6326c",
  null
  
)

export default component.exports